<template>
  <v-dialog
    v-model="switchDialog.show"
    :max-width="$spec.dialog_standard_max_width"
  >
    <v-card>
      <v-card-title class="headline">診所切換</v-card-title>
      <v-card-text>
        <v-select
          v-model="switchDialog.clinic"
          label="診所名稱"
          item-text="text"
          item-value="value"
          :items="clinicList"
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="switchDialog.show = false">取消</v-btn>
        <v-btn color="green darken-1" text @click="go">切換</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: thisVm => ({
    switchDialog: {
      show: false,
      clinic: thisVm.$my.getClinic()
    },
    clinicList: []
  }),
  methods: {
    async show() {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/clinicData/0`
      );
      console.log("response.data:" + JSON.stringify(response.data));
      this.clinics = response.data;

      this.clinicList.push({
        text: "總管理者",
        value: ""
      });
      let clinicList = this.clinicList;
      this.clinics.forEach(clinic => {
        clinicList.push({
          text: `${clinic.name}(${clinic.clinic})`,
          value: clinic.clinic
        });
      });
      this.switchDialog.show = true;
    },
    async go() {
      this.$my.setClinic(this.switchDialog.clinic);
      this.switchDialog.show = false;
      try {
        await this.$router.replace("/");
      } catch (e) {
        this.$router.go(0);
      }
    }
  }
};
</script>
